import { connect } from 'react-redux'
import { compose } from 'redux'
import { reduxForm } from 'redux-form'
import { change as formValueChange } from 'redux-form'
import { withStyles } from '@material-ui/core'

import {
  isDisabledSelector,
  routeIdSelector,
  shownRoutesSelector,
  limitSelector,
} from 'reduxModules/selectors/RouteSelectors'
import { citiesPriceSelector } from 'reduxModules/selectors/PriceSelectors'
import { withoutBusStationsSelector } from 'reduxModules/selectors/SourceSelectors'
import { isPartnerSelector, isLimitedDispatcherSelector } from 'reduxModules/selectors/UserSelectors'
import { isLoadingSelector, departureTimeSelector } from 'reduxModules/selectors/BookSelectors'
import { priceActions } from 'reduxModules/actions/PriceActions'
import { bookActions } from 'reduxModules/actions/BookActions'
import { routeActions } from 'reduxModules/actions/RouteActions'

import { BookFormBase } from './BookForm'

import { styles } from './styles'

const mapStateToProps = (state, props) => ({
  isDisabled: isDisabledSelector(state, props),
  isLoading: isLoadingSelector(state, props),
  isPartner: isPartnerSelector(state, props),
  isLimitedDispatcher: isLimitedDispatcherSelector(state, props),
  routeId: routeIdSelector(state, props),
  sources: withoutBusStationsSelector(state, props),
  shownRoutes: shownRoutesSelector(state, props),
  citiesPrice: citiesPriceSelector(state, props),
  departureTime: departureTimeSelector(state, props),
  initialValues: {
    limit: limitSelector(state, props)
  }
})

const mapDispatchToProps = {
  getCitiesRoutePrice: priceActions.getCitiesRoutePrice,
  getDepartureTime: bookActions.getDepartureTime,
  formValueChange: formValueChange,
  addBooking: bookActions.addBooking,
  changeRouteLimit: routeActions.changeRouteLimit
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'book',
    enableReinitialize: true,
    keepDirtyOnReinitialize: true
  }, mapStateToProps),
  withStyles(styles)
)

export const BookForm = enhance(BookFormBase)



// WEBPACK FOOTER //
// ./src/components/BookForm/index.js